const moment = require("moment");

export const preventFutureDatesComparator = (
  filterLocalDateAtMidnight,
  cellValue
) => {
  if (cellValue == null) {
    return 0;
  }
  const cellDate = new Date(cellValue);
  if (cellDate.getTime() > new Date().getTime()) {
    return 1;
  } else {
    return cellDate.getTime() - filterLocalDateAtMidnight.getTime();
  }
};

export const isStringDate = (str) => {
  return moment(str).isValid();
};

export const getLastNyears = ({ length = 3 }) =>
  Array.from(Array(length).keys())?.map((number) => {
    const now = new Date();
    return {
      year: now.getFullYear() - number,
      label: `${now.getFullYear() - number - 1}- ${now.getFullYear() - number}`,
    };
  });

export const getLastSixMonths = () => {
  const months = [];
  const currentDate = new Date();
  for (let i = 5; i >= 0; i--) {
    const targetDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i,
      1
    );
    const monthName = targetDate.toLocaleString("default", { month: "long" });
    const monthNumber = targetDate.getMonth() + 1;
    const yearName = targetDate.getFullYear();
    const monthYear = { month: monthName, year: yearName, number: monthNumber };
    months.push(monthYear);
  }
  return months;
};

export const getLastNMonths = ({ number }) => {
  const months = [];
  const currentDate = new Date();
  for (let i = number - 1; i >= 0; i--) {
    const targetDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i,
      1
    );
    const monthName = targetDate.toLocaleString("default", { month: "long" });
    const monthNumber = targetDate.getMonth() + 1;
    const yearName = targetDate.getFullYear().toString().slice(-2);
    const fullYear = targetDate.getFullYear();
    const monthString = `${targetDate.toLocaleString("default", {
      month: "short",
    })}' ${yearName}`;

    const date = new Date().getDate();
    const monthYear = {
      month: monthName,
      year: yearName,
      number: monthNumber,
      monthString: monthString,
      date,
      fullYear,
    };
    months.push(monthYear);
  }
  return months.sort();
};

export const Last3MonthWiseLists = [
  { id: 0, title: "Last 12 Months", value: 12 },
  { id: 1, title: "Last 9 Months", value: 9 },
  { id: 2, title: "Last 6 Months", value: 6 },
  { id: 3, title: "Last 3 Months", value: 3 },
];

export const multipleOfNNumber = (num, divident) => {
  let rounded = Math.ceil(num / divident);
  return rounded * divident;
};

export const countWeeksInYear = (year) => {
  // Use isoWeeksInYear for weeks considering leap years (ISO standard)
  return moment([year]).isoWeeksInYear();
};

export const getFirstNDayofYear = (day, startDate) => {
  const januaryFirst = moment(startDate);
  return januaryFirst.startOf("month").day(day).format("MM-DD-YYYY");
};

export const getDatesByaDifference = (day, difference = 7, year) => {
  const days = [];

  let firstDay = moment([year, 0]).startOf("year").format("MM-DD-YYYY");

  const startDate =
    day === ""
      ? moment([year, 0]).startOf("year")
      : moment(getFirstNDayofYear(day, firstDay)); // Set to Jan 1st

  const endDate = moment([year, 11]).endOf("year"); // Set to Dec 31st

  let currentDate = startDate.clone();
  while (currentDate.isSameOrBefore(endDate)) {
    days.push(currentDate.format("MM-DD-YYYY")); // Formatted date string (YYYY-MM-DD)
    currentDate.add(difference, "days"); // Move to next 7th day (might go beyond the year)
  }

  return days;
};

export const getDatesExceptHolidays = (year, month, holidays) => {
  const firstDayOfMonth = moment([year, month, 1]);
  const lastDayOfMonth = moment(firstDayOfMonth).endOf("month");
  const validDates = [];
  let currentDate = firstDayOfMonth;
  while (currentDate.isSameOrBefore(lastDayOfMonth)) {
    const dayName = currentDate.format("ddd").toLowerCase();
    if (!holidays.includes(dayName)) {
      validDates.push(currentDate.format("MM-DD-YYYY"));
    }
    currentDate.add(1, "day");
  }

  return validDates;
};

export const getDatesExceptHolidaysInYear = (year, month, holidays) => {
  const firstDayOfMonth = moment([year, 0, 1]);
  const lastDayOfMonth = moment(firstDayOfMonth).endOf("year");
  const validDates = [];
  let currentDate = firstDayOfMonth;
  while (currentDate.isSameOrBefore(lastDayOfMonth)) {
    const dayName = currentDate.format("ddd").toLowerCase();
    if (!holidays.includes(dayName)) {
      validDates.push(currentDate.format("MM-DD-YYYY"));
    }
    currentDate.add(1, "day");
  }

  return validDates;
};


export const getCalendarData = ({ currentMonth, currentYear, offset }) => {
  const getMonthName = (month) => new Date(currentYear, month).toLocaleString('default', { month: 'short' });

  const generateMonths = (offset) => {
      const months = [];
      for (let i = currentMonth - offset; i <= currentMonth + offset; i++) {
          const month = (i + 12) % 12;
          const year = currentYear + Math.floor((i + 12) / 12) - 1;
          months.push({ month: Math.abs(month) +1, year: Math.abs(year), monthName: getMonthName(month) });
      }
      return months;
  };

  return generateMonths(offset)
};

export const getCurrentFinancialYear = () => {
  const today = new Date();
  const curMonth = today.getMonth();
  
  const fiscalYear = curMonth >= 3 
    ? `${today.getFullYear()}}` 
    : `${today.getFullYear() - 1}`;

  return fiscalYear;
};

